<div class="main-container">
  <div class="content-wrapper">
    <div class="container">

<!--      <div class="row">
        <ol class="breadcrumb backgroundclr">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          &lt;!&ndash; <li class="breadcrumb-item"><a href="#">Sports</a></li> &ndash;&gt;
          <li class="breadcrumb-item"><a href="#">{{tenant?.tenantName}}</a></li>
          <li class="breadcrumb-item active" aria-current="page">Book Now</li>
        </ol>
      </div>-->

      <div class="row" style="padding-top: 20px;">
        <!-- NO SERVICES AVAILABLE -->
        <div class="col-md-12 text-center" *ngIf="products && products.length === 0">
          <!--<div class="card border-light mb-4">
            <div class="card-body" style="padding:40px;">-->
              <div class="col-md-12 marg-right-mobile">
                <h4 class="header-title">
                  {{tenant?.tenantName}} <br>
                  <!-- <span class="bottom-text">{{categoryArr[0]}}</span> -->
                </h4>
              </div>
              <p class = "blueText" style="margin-top:30px; margin-bottom:30px;">
                Please contact the facility for bookings.
              </p>

              <div *ngIf="tenant?.contactPhoneNumber1 || tenant?.contactPhoneNumber2 || tenant?.contactPhoneNumber3 || tenant?.phoneNumber">

                <p class = "blueText" style="margin-bottom:20px;">
                  Contact Numbers
                </p>

                <div *ngIf="tenant?.contactPhoneNumber1">
                  <p>
                    <a href="tel:{{tenant.contactPhoneNumber1}}">
                      {{tenant.contactPhoneNumber1}}
                    </a>
                  </p>
                </div>

                <div *ngIf="tenant?.contactPhoneNumber2">
                  <p>
                    <a href="tel:{{tenant.contactPhoneNumber2}}">
                      {{tenant.contactPhoneNumber2}}
                    </a>
                  </p>
                </div>

                <div *ngIf="tenant?.contactPhoneNumber3">
                  <p>
                    <a href="tel:{{tenant.contactPhoneNumber3}}">
                      {{tenant.contactPhoneNumber3}}
                    </a>
                  </p>
                </div>

                <!-- fallback -->
                <div *ngIf="
            !tenant?.contactPhoneNumber1 &&
            !tenant?.contactPhoneNumber2 &&
            !tenant?.contactPhoneNumber3 &&
            tenant?.phoneNumber
          ">
                  <h5>
                    <a href="tel:{{tenant.phoneNumber}}">
                      {{tenant.phoneNumber}}
                    </a>
                  </h5>
                </div>

         <!--     </div>

            </div>-->
          </div>
        </div>
        <!-- TODO height 287px when new content is added bofere footer and after this division -->
        <div class="col-md-8 col-lg-8 product-panel" *ngIf="(products && products.length > 0) || addOns.length > 0">
          <div class="row">
            <div class="col-md-12 marg-right-mobile">
              <h5 class="header-title">
                {{tenant?.tenantName}} <br>
                <!-- <span class="bottom-text">{{categoryArr[0]}}</span> -->
              </h5>
            </div>
            <div class="col-md-12 marg-right-mobile">
              <form>
                <div class="form-row product-form">
                  <div class="row">
                     <div class="form-group col-md-6">
                      <label for="inputState">SERVICE</label>
                      <!-- <select #selectedService id="inputState" class="form-control" (change)="onChangeService($event.target.value)" *ngIf="isCatProd">
                        <option *ngFor="let service of categoryAndProduct.Badminton" value="{{service.id}}">{{service.name}}</option>
                      </select> -->
                      <select #selectedService id="inputState" class="form-control" (change)="onChangeService($event.target.value)">
                        <!-- <option *ngFor="let service of products" value="{{service.venueType}}">{{service.productName}}</option> -->
                        <!-- <option value="" disabled>Select Service</option> -->
                        <!-- For NEW API <option *ngFor="let service of productByCat" value="{{service.id}}">{{service.name}}</option> -->
                        <ng-container *ngFor="let service of products" >
                          <!-- [selected] keeps the dropdown in sync with what the page shows (otherwise the browser
                               pre-selects whichever option is rendered first, which can be an addOn). -->
                          <option  *ngIf="service.status === 'Active'" value="{{service.id}}"
                                   [selected]="!showAddOns && products[selectedProductIndex]?.id === service.id">{{service.productName}}</option>
                        </ng-container>
                        <option *ngFor="let addOn of addOns" [value]="ADD_ONS_OPTION + addOn.id"
                                [selected]="showAddOns && selectedAddOn?.id === addOn.id">{{addOn.productName}}</option>
                      </select>

                      <ng-container *ngIf="!showAddOns">
                       <div class="service-tags">

                         <div class="service-tag">
                           <img
                             [src]="getServiceTypeIcon()"
                             alt="Service Type"
                           />
                           {{getServiceName(selectedProductServiceTypeIconFileName)}}
                         </div>

                         <div
                           class="service-tag"
                           *ngIf="products[selectedProductIndex]?.isCoaching"
                         >
                           <img
                             [src]="getCoachingIcon()"
                             alt="Coaching"
                           />
                           <span>Coaching</span>
                         </div>

                       </div>
                       <!-- Product Description -->
                       <div
                         class="service-description-card"
                         *ngIf="products && products[selectedProductIndex]?.description"
                       >
                         <div class="service-description-header">
                           <i class="bi bi-info-circle-fill"></i>
                           <span>Service Details</span>
                         </div>
                         <div class="service-description-text">
                           {{ products[selectedProductIndex]?.description }}
                         </div>
                       </div>
                      </ng-container>


                    </div>
                    <div  class="quick-date-container"
                        *ngIf="selectedServiceType === 'Single Session'
                      ">
                      <div class="quick-date-scroll">

                        <div
                          *ngFor="let d of quickDates"
                          class="quick-date-chip"
                          [class.active]="d.value === selectedQuickDate"
                          (click)="onQuickDateSelect(d.value)"
                        >
                          {{ d.label }}
                        </div>

                      </div>
                    </div>
                     <!--This Code allows bookings upto a month from the current date-->
                    <div *ngIf=" selectedServiceType === 'Single Session' " class="col-md-6 form-group">
                      <label for="toDate">DATE</label>
                      <div class="input-group">
                        <input type="date" [ngModel]="latest_date1 | date:'yyyy-MM-dd'"
                               class="form-control"
                               placeholder="yyyy-mm-dd"
                               name="toDate"
                               [min]="minDate"
                               [max]="maxDate"
                               (change)="onDateChange($event.target.value)"
                               (focus)="clearDate()" >
                      </div>
                    </div>
                    <div
                      *ngIf=" selectedServiceType === 'Multi Session' &&
                          products[selectedProductIndex]?.allowBooking !== false"
                      class="col-md-6 form-group"
                    >
                      <div *ngIf="sessionType === 'Monthly'">

                        <label for="startDate">SELECT THE START DATE</label>
                        <!--<div class="input-group">
                          <input
                            type="date"
                            [ngModel]="latest_date1 | date:'yyyy-MM-dd'"
                            class="form-control"
                            placeholder="yyyy-mm-dd"
                            name="toDate"
                            [min]="minDate"
                            [max]="maxDate"
                            [attr.disabledDates]="monthlyMultiBookingSelectedDates"
                            (change)="onDateChange1($event.target.value)"
                          >
                        </div>-->

                        <div *ngIf="monthlyMultiBookingOption === 'Selected Dates'">
                          <div *ngIf="monthlyMultiBookingSelectedDates.length > 0;">
                            <form>
                              <div *ngFor="let date of futureDates; let i = index">
                                <label>
                                  <input
                                    type="radio"
                                    name="startDate"
                                    [value]="date"
                                    [(ngModel)]="selectedStartDate"
                                    (change)="onStartDateChange(selectedStartDate)"
                                    [checked]="i === 0"
                                  />
                                  {{ date }}
                                </label>
                              </div>
                            </form>
                            <p>Selected Date: {{ selectedStartDate }}</p>
                          </div>
                        </div>

                        <!-- Date Picker for "Select Any Day" Option -->
                        <div *ngIf="monthlyMultiBookingOption === 'Start Any Day'">
                          <div class="input-group">
                            <input type="date" [ngModel]="latest_date1 | date:'yyyy-MM-dd'"
                                   class="form-control"
                                   placeholder="yyyy-mm-dd"
                                   name="toDate"
                                   [min]="minDate"
                                   [max]="maxDate"
                                   (change)="onDateChange($event.target.value)"
                                   (focus)="clearDate()" >
                          </div>
                        </div>
                      </div>
                      <div *ngIf="sessionType === 'Sessions'">
                        <label for="toDate">SELECT THE START DATE</label>
                        <div class="input-group">
                          <input type="date" [ngModel]="latest_date1 | date:'yyyy-MM-dd'"
                                 class="form-control"
                                 placeholder="yyyy-mm-dd"
                                 name="toDate"
                                 [min]="minDate"
                                 [max]="maxDate"
                                 (change)="onDateChange($event.target.value)"
                                 (focus)="clearDate()" >
                        </div>
                      </div>
                    </div>


                    <!-- This code does not have control over the booking date. It can go to any date in the future.
                    <div class="col-md-6 form-group" >
                      <label for="">DATE</label>
                      <div class="input-group">
                        <input type="date" [ngModel]="latest_date1 | date:'yyyy-MM-dd'" class="form-control" placeholder="yyyy-mm-dd" value="{{latest_date1}}" name="toDate" min="{{latest_date1}}" [(ngModel)]="toDate" (change)="onDateChange($event.target.value)">
                      </div>
                    </div>-->
                  </div>
                </div>

                <!-- Service Enquiry -->
                <div
                  class="service-description-card"
                  *ngIf="showEnquiryForm"
                >

                  <h6 *ngIf=" selectedServiceType === 'Multi Session'" class="service-description-header" ><i class="bi bi-chat-dots-fill me-2"></i>Request Booking Enquiry</h6>
                  <h6 *ngIf=" selectedServiceType === 'Single Session'" class="service-description-header" ><i class="bi bi-chat-dots-fill me-2"></i>Slots are not available, Request Booking Enquiry</h6>

                  <div class="form-group mt-3">
                    <label>Preferred Date</label>
                    <input
                      type="date"
                      class="form-control"
                      [(ngModel)]="serviceEnquiryDate"
                      [min]="minDate"
                      name="serviceEnquiryDate"
                    />
                  </div>

                  <div class="form-group mt-3">
                    <label>Preferred Time</label>

                    <select
                      class="form-control"
                      [(ngModel)]="serviceEnquiryTime"
                      name="serviceEnquiryTime"
                    >
                      <option value="">Select Time Slot</option>

                      <option
                        *ngFor="let ts of enquiryTimeSlots"
                        [value]="ts"
                      >
                        {{ ts }}
                      </option>
                    </select>
                  </div>

                  <button
                    class="btn btn-primary mt-3"
                    (click)="submitServiceEnquiry()"
                  >
                    Send Enquiry
                  </button>
                </div>

                <!-- AddOns (picked from the SERVICE dropdown) -->
                <div class="addons-section" *ngIf="showAddOns">
                  <div class="addons-heading">Add-On</div>
                  <div class="addons-grid">
                    <div class="addon-card" *ngFor="let addOn of selectedAddOn ? [selectedAddOn] : addOns">
                      <div class="addon-body">
                        <div class="addon-name">{{ addOn.productName }}</div>
                        <div class="addon-price">Rs {{ addOn.price | number:'1.2-2' }}/-</div>
                        <div class="addon-description" *ngIf="addOn.description">{{ addOn.description }}</div>
                        <div class="addon-actions">
                          <div class="addon-quantity-field">
                            <label class="addon-qty-label" [attr.for]="'addon-qty-' + addOn.id">Qty</label>
                            <div class="addon-quantity-controls">
                              <button type="button" class="addon-quantity-step" aria-label="Decrease quantity"
                                      [disabled]="getAddOnQuantity(addOn) <= 1"
                                      (click)="changeAddOnQuantity(addOn, -1)">&minus;</button>
                              <input type="number" inputmode="numeric" class="form-control addon-qty" [id]="'addon-qty-' + addOn.id"
                                     min="1" [max]="MAX_ADD_ON_QUANTITY" step="1"
                                     [ngModel]="getAddOnQuantity(addOn)"
                                     (ngModelChange)="addOnQuantities[addOn.id] = $event"
                                     [ngModelOptions]="{standalone: true}" />
                              <button type="button" class="addon-quantity-step" aria-label="Increase quantity"
                                      [disabled]="getAddOnQuantity(addOn) >= MAX_ADD_ON_QUANTITY"
                                      (click)="changeAddOnQuantity(addOn, 1)">+</button>
                            </div>
                          </div>
                          <button type="button" class="btn addon-submit" (click)="addAddOnToBooking(addOn)">
                            {{ selectedAddOnsMap.has(addOn.id) ? 'Update' : 'Add' }}
                          </button>
                        </div>
                        <div class="addon-in-cart" *ngIf="selectedAddOnsMap.get(addOn.id) as added">
                          Added: {{ added.quantity }} &times; Rs {{ added.unitPrice | number:'1.2-2' }}
                          <button type="button" class="addon-remove" (click)="removeAddOnFromBooking(addOn.id)">Remove</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row product-form" *ngIf="!showAddOns">
                  <div class="row">
                    <ul>
                      <li *ngFor="let day of days">
                        {{ day }}
                      </li>
                    </ul>
                  </div>
                  <div
                    *ngIf="
                        products[selectedProductIndex]?.allowBooking !== false &&
                        allSlots &&
                        allSlots.length > 0
                      "
                  >
                    <div class="slot-header-row">

                      <div class="slot-title">
                        <label>SELECT SLOT FOR BOOKING</label>
                      </div>

                      <div class="slot-legends">

                        <div class="slot-legend-item">
                          <div id="avail_slots"></div>
                          <span>Available</span>
                        </div>

                        <div class="slot-legend-item">
                          <div class="yourBk slot_selected" id="your_booking"></div>
                          <span>Selected : {{numberOfSlotsSelected}}</span>
                        </div>

                      </div>

                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <div class="court-box" *ngFor="let slotItem of allSlots; let alindx = index">
                          <div>
                              <div class="blueText" style="font-size: 13px; background: #DFF5F2;text-transform: uppercase; text-align: center; word-wrap: break-word;">
                                 {{slotItem?.type}}
                              </div>
                          </div>

                            <div class="row" style="padding-top: 10px; padding-left: 5px;" >
                              <div class="col-md-4 col-sm-12 slots-session" *ngIf="slotItem?.before12">
                                <div class= "orangeText" style="text-align: center;font-size: 11px;">Morning</div>
                                <div class="row justify-content-center">
                                  <div *ngFor="let slot of slotItem?.before12; let slotId = index" class="box-div {{bntStyle}} {{slotItem?.mainService}}" [ngStyle]="{'background-color': getSlotBGColor(slot.uniqueId)}" (click)="getSlotsDetails_TD($event, slot.uniqueId, slot.venueId, slot.startTime, slot.endTime, slot.price, slotId, slotItem?.type, slotItem?.mainService)" id="slot_{{slot.id}}">
                                    <!--<div *ngFor="let slot of slotItem?.before12; let slotId = index" class="box-div {{bntStyle}} {{slotItem?.mainService}}" (click)="getSlotsDetails($event, slot.startTime, slot.endTime, slot.price, slotId, slotItem?.type, slotItem?.mainService)" id="slot_{{slot.id}}">-->
                                    <h6 class="time-h6" style="font-size: 10px;">{{ slot.startTime }}</h6>
                                    <!-- <h6 class="time-h6">{{ slot.endTime }}</h6> -->
                                    <span class="price-sp" style="font-size: 9px;">{{ slot.price | number:'1.2-2'}}/-</span>
                                    <!--<div class="priceSp1" *ngIf="onSinglehide">67%</div>-->
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4 slots-session" *ngIf="slotItem?.bwtn12To6">
                                <div class= "orangeText" style="text-align: center;font-size: 11px;">Afternoon</div>
                                <div class="row justify-content-center">
                                  <div *ngFor="let slot of slotItem?.bwtn12To6; let slotId = index" class="box-div {{bntStyle}} {{slotItem?.mainService}}" [ngStyle]="{'background-color': getSlotBGColor(slot.uniqueId)}" (click)="getSlotsDetails_TD($event, slot.uniqueId, slot.venueId, slot.startTime, slot.endTime, slot.price, slotId, slotItem?.type, slotItem?.mainService)" id="slot_{{slot.id}}">
                                    <h6 class="time-h6" style="font-size: 10px;">{{ slot.startTime }}</h6>
                                    <span class="price-sp" style="font-size: 9px;">{{ slot.price | number:'1.2-2'}}/-</span>
                                    <!--<div class="priceSp1" *ngIf="onSinglehide">67%</div>-->
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4 slots-session" *ngIf="slotItem?.after6">
                                <div class= "orangeText" style="text-align: center;font-size: 11px;">Evening</div>
                                <div class="row justify-content-center">
                                  <div *ngFor="let slot of slotItem?.after6; let slotId = index" class="box-div {{bntStyle}} {{slotItem?.mainService}}" [ngStyle]="{'background-color': getSlotBGColor(slot.uniqueId)}" (click)="getSlotsDetails_TD($event, slot.uniqueId, slot.venueId, slot.startTime, slot.endTime, slot.price, slotId, slotItem?.type, slotItem?.mainService)" id="slot_{{slot.id}}">
                                    <h6 class="time-h6" style="font-size: 10px;">{{ slot.startTime }}</h6>
                                    <span class="price-sp" style="font-size: 9px;">{{ slot.price | number:'1.2-2'}}/-</span>
                                    <!--<div class="priceSp1" *ngIf="onSinglehide">67%</div>-->
                                  </div>
                                </div>
                              </div>
                            </div>
                          <!--</div>-->
                        </div>
                      </div>
                    </div>
                    <!--- Only Mobile Buttons-->
                    <div class="row d-block d-sm-none fixed-bottom mobile-bottom-btns" *ngIf="!isBillDeskPaymentActive">
                      <div class="mobile-btn cancel">
                        <button type="button" class="btn" (click)="cancelSlots()">Cancel</button>
                      </div>
                      <div class="mobile-btn book-now">
                        <button type="button"  (click)="showModal()" class="btn">Book Now</button>
                      </div>
                    </div>
                    <!--- Only Mobile Buttons-->

                    <!--<div class="row mainSlots">
                      <div class="col-md-4 col-6  avl-slots">
                        <div id="avail_slots"></div> Available Slots
                      </div>
                      <div class="col-md-4 col-6 your-booking">
                        <div class="yourBk slot_selected" id="your_booking"></div> Your Booking
                      </div>
                      <div class="col-md-4 slot-booked">
                        Slots Selected : {{numberOfSlotsSelected}}
                        &lt;!&ndash;Slots Booked : {{bookedslotsLength}}/{{slotsAllLength}}&ndash;&gt;
                        &lt;!&ndash; Slots Booked : {{timeSlotsArr?.length}}/{{allSlots?.length}} &ndash;&gt;
                      </div>
                    </div>-->


                  </div>
                  <div *ngIf="allSlots && allSlots.length === 0"style="text-align:center;">

                    <h6>No slots are available</h6>

                  </div>
                  <div class="row mbl-btn d-none d-sm-block">
                    <button type="submit" class="btn btn-outline-dark cancel_btn" (click)="cancelSlots()">Cancel</button>
                  </div>

                </div>

                  <!-- The Modal -->
                  <div class="modal fade bd-example-modal-lg" id="myModal" tabindex="-1" aria-labelledby="booking-confirmation-title">
                    <div class="modal-dialog modal-lg modal-dialog-scrollable">
                      <div class="modal-content booking-confirm-content">

                        <!-- Modal Header -->
                        <div class="modal-header booking-confirm-header">
                          <div>
                            <h4 class="modal-title booking-confirm-title" id="booking-confirmation-title">Confirm Details</h4>
                            <p class="booking-confirm-subtitle">Review your booking before payment</p>
                          </div>
                          <!-- <button type="button" class="close" (click)="hideModal()">&times;</button> -->
                        </div>

                        <!-- Modal body -->
                        <div class="modal-body booking-confirm-body">
                          <div class="row">
                            <div class="col-12 booking-confirm-main">
                              <div class="booking-confirm-section">
                                <label class="booking-section-title">Facility Details</label>
                                <table class="table table-borderless details-table booking-detail-table">
                                  <tr>
                                    <td>NAME</td>
                                    <td>{{tenant?.tenantName}}</td>
                                  </tr>
                                  <tr>
                                    <td>ADDRESS</td>
                                    <td>{{tenant?.address?.addressLine1}}, {{tenant?.address?.addressLine2}}, {{tenant?.address?.city}}, {{tenant?.address?.pinCode}}, </td>
                                  </tr>
                                </table>
                              </div>
                              <div class="booking-confirm-section">
                                <label class="booking-section-title">User Details</label>
                                <table class="table table-borderless details-table booking-detail-table">
                                  <tr>
                                    <td>NAME</td>
                                    <td>{{user?.firstName}} {{user?.lastName}}</td>
                                  </tr>
                                  <tr>
                                    <td>EMAIL ID</td>
                                    <td>{{user?.email}}</td>
                                  </tr>
                                  <tr>
                                    <td>PHONE NO</td>
                                    <td>
                                      <span *ngIf="!isPhoneInputRequired">{{user?.phoneNumber}}</span>
                                      <ng-container *ngIf="isPhoneInputRequired">
                                        <input
                                          type="tel"
                                          inputmode="numeric"
                                          autocomplete="tel-national"
                                          aria-label="Phone number"
                                          name="phoneNumber"
                                          [(ngModel)]="user.phoneNumber"
                                          #phoneInput="ngModel"
                                          [pattern]="'^[6-9]\\d{9}$'"
                                          required
                                          class="form-control"
                                          style="max-width: 200px;"
                                          placeholder="Enter phone number"
                                        />
                                        <div *ngIf="showPhoneError || (phoneInput.invalid && phoneInput.touched)" style="color: red; font-size: 0.8rem;">
                                          Please enter a valid 10-digit mobile phone number.
                                        </div>
                                      </ng-container>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              <div class="booking-confirm-section">
                                <label class="booking-section-title">Booking Details</label>

                                <!-- Slots -->
                                <div class="booking-items" *ngIf="selectedSlotsMap.size">
                                  <div class="booking-items-title">Slots ({{selectedSlotsMap.size}})</div>
                                  <div class="booking-slot-card" *ngFor="let slotObj of selectedSlotsMap | keyvalue">
                                    <div class="booking-item-name">{{slotObj.value.ss_service}} : {{slotObj.value.ss_slotType}}</div>
                                    <div class="booking-item-details">
                                      <span>{{slotObj.value.ss_slotDate}}</span>
                                      <span>{{slotObj.value.ss_startTime}} - {{slotObj.value.ss_endTime}}</span>
                                      <span class="booking-item-amount">Rs {{slotObj.value.amount | number:'1.2-2'}}</span>
                                      <button type="button" class="booking-item-remove" aria-label="Remove slot" (click)="deleteSelectedSlot($event, slotObj)">
                                        <i class="bi bi-trash" aria-hidden="true"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <!-- AddOns -->
                                <div class="booking-items" *ngIf="selectedAddOnsMap.size">
                                  <div class="booking-items-title">Add-On ({{selectedAddOnsMap.size}})</div>
                                  <div class="booking-slot-card" *ngFor="let addOnObj of selectedAddOnsMap | keyvalue">
                                    <div class="booking-item-name">{{addOnObj.value.productName}}</div>
                                    <div class="booking-item-details booking-addon-details">
                                      <span>{{addOnObj.value.quantity}} &times; Rs {{addOnObj.value.unitPrice | number:'1.2-2'}}</span>
                                      <span class="booking-item-amount">Rs {{addOnObj.value.amount | number:'1.2-2'}}</span>
                                      <button type="button" class="booking-item-remove" aria-label="Remove Add-On" (click)="removeAddOnFromBooking(addOnObj.value.productId)">
                                        <i class="bi bi-trash" aria-hidden="true"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="section-divider booking-confirm-section">
                                <label class="booking-section-title">Payment</label>
                                <table class="table table-borderless details-table payment-table booking-detail-table">
                                  <tr *ngIf="selectedSlotsMap.size">
                                    <td>SLOTS</td>
                                    <td>Rs. {{totalForSlots | number:'1.2-2'}}/-</td>
                                  </tr>
                                  <tr *ngIf="selectedAddOnsMap.size">
                                    <td>Add-On</td>
                                    <td>Rs. {{totalForAddOns | number:'1.2-2'}}/-</td>
                                  </tr>
                                  <tr>
                                    <td>PLATFORM FEE</td>
                                    <td>Rs. {{totalPlatformFeeForBooking | number:'1.2-2'}}/-</td>
                                  </tr>
                                  <tr class="total-row">
                                    <td>TOTAL</td>
                                    <td class="bold">Rs. {{totalSum | number:'1.2-2'}}/-</td>
                                  </tr>
                                </table>
                              </div>
                              <!-- Warning 1: Do not refresh -->
                              <div class="card bg-light border-warning mb-3 booking-warning-card">
                                <div class="card-body d-flex align-items-start">
                                  <i class="bi bi-exclamation-triangle-fill text-warning me-2 mt-1"></i>
                                  <div>
                                    <h6 class="card-title mb-1 fw-bold" style="color:red;">Important</h6>
                                    <p class="card-text mb-0">
                                      After clicking "Pay Now", please do not refresh or close the payment screen until the payment is completed. If the process is interrupted, your selected slots will remain locked for 5 minutes.
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <!-- Warning 2: Transaction charges -->
                             <!-- <div class="card bg-light border-warning mb-3">
                                <div class="card-body d-flex align-items-start">
                                  <i class="bi bi-exclamation-triangle-fill text-warning me-2 mt-1"></i>
                                  <div>
                                    <h6 class="card-title mb-1 fw-bold" style="color:red;">Transaction Charges May Apply</h6>
                                    <div class="charge-row"><span class="method">UPI (Bank-linked)</span><span class="charge">No Charge</span></div>
                                    <div class="charge-row"><span class="method">UPI (Credit Card-linked)</span><span class="charge">3%</span></div>
                                    <div class="charge-row"><span class="method">Wallets</span><span class="charge">3%</span></div>
                                    <div class="charge-row"><span class="method">Credit/Debit Card, Netbanking</span><span class="charge">3%</span></div>
                                  </div>
                                </div>
                              </div>-->



                            </div>
                            <!--<div class="justify-content-center">
                                <button type="button" class="btn btn-outline-dark cancel_btn" id="close-modal" (click)="hideModal()">Cancel</button>
                                <button type="button" class="btn btn-primary book-now-btn">Pay Now</button>
                            </div>-->
                          </div>
                        </div>
                        <div class="modal-footer booking-actions" *ngIf="!isBillDeskPaymentActive">
                          <button type="button" class="btn booking-cancel-action" id="close-modal" (click)="hideModal()">Cancel</button>
                          <button type="button" class="btn booking-pay-action book-now-btn" (click)="confirmBooking()">Pay Now</button>
                        </div>
                      </div>
                    </div>
                  </div>
              </form>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-lg-4 summary-panel" *ngIf="(products && products.length > 0) || addOns.length > 0">
          <div class="card border-light mb-4">
            <h5 class="card-header bg-transparent border-light">Summary Panel
              <!-- <span class="slot-text">1 Slot</span> -->
            </h5>
            <div class="card-body"style="height: 450px;overflow-y: auto">
              <div class="row">
                <div class="col-md-12 booking-details">
                  <div class="summary-slots-details">
                    <div class="row margin-0">
                      <div class="col-md-6" *ngIf="hasItemsInCart">
                        <h6 style="padding-top:7px;font-size:1.0rem bold;font-family: 'OpenSans-B';line-height: 25px;">Sum: Rs {{totalForSlots + totalForAddOns | number:'1.0-2'}}/-</h6>
                      </div>
                      <div class="col-md-6" *ngIf="!hasItemsInCart">
                        <h6 style="padding-top:7px;font-size:1.0rem;font-family: 'Nunito-R';line-height: 25px;">Add Slots for Booking</h6>
                      </div>
                      <div class="col-md-6 bg-transparent border-light" *ngIf="!hasItemsInCart">
                        <button type="button" disabled  (click)="showModal()" class="btn btn-secondary book-now-btn-disabled float-right d-none d-sm-block" >Book Now</button>
                      </div>
                      <div class="col-md-6 bg-transparent border-light" *ngIf="hasItemsInCart">
                        <button type="button" enabled  (click)="showModal()" class="btn btn-secondary book-now-btn float-right d-none d-sm-block" >Book Now</button>
                      </div>
                    </div>
                    <div class="row summary-slots-row" >

                      <table width="100%" *ngFor="let slotObj of selectedSlotsMap | keyvalue;" class="trash_{{slotObj.trash}}">
                        <tr>
                          <td colspan="10" class="bold" style="font size; font-family: 'Nunito-R' !important;">{{slotObj.value.ss_service}} : {{slotObj.value.ss_slotType}}</td>
                          <!--<td colspan="8" class="bold" style="font-size: bold; font-family: 'OpenSans-B'">{{key.value.ss_service}} : {{key.value.ss_slotType}}</td>-->
                        </tr>
                        <tr>
                          <td  style=" padding-right: 2px; text-align: left;  font-size: 0.8rem; !important;" >{{slotObj.value.ss_slotDate}}</td>
                          <td style=" padding-right: 2px; text-align: left;  font-size: 0.8rem; !important;">{{slotObj.value.ss_startTime}}-{{slotObj.value.ss_endTime}}</td>
                          <td style=" padding-right: 2px; text-align: left;  font-size: 0.8rem; !important;">{{ slotObj.value.amount | number:'1.2-2'}}</td>
                          <td align="left" valign="middle" style=" padding-right: 2px; !important;" >
                            <i class="bi bi-trash" (click)="deleteSelectedSlot($event, slotObj)"></i>
                          </td>
                        </tr>
                      </table>

                      <table width="100%" *ngFor="let addOnObj of selectedAddOnsMap | keyvalue;">
                        <tr>
                          <td colspan="10" class="bold" style="font-family: 'Nunito-R' !important;">Add-On : {{addOnObj.value.productName}}</td>
                        </tr>
                        <tr>
                          <td style="padding-right: 2px; text-align: left; font-size: 0.8rem;">Qty {{addOnObj.value.quantity}}</td>
                          <td style="padding-right: 2px; text-align: left; font-size: 0.8rem;">&times; {{addOnObj.value.unitPrice | number:'1.2-2'}}</td>
                          <td style="padding-right: 2px; text-align: left; font-size: 0.8rem;">{{addOnObj.value.amount | number:'1.2-2'}}</td>
                          <td align="left" valign="middle" style="padding-right: 2px;">
                            <i class="bi bi-trash" (click)="removeAddOnFromBooking(addOnObj.value.productId)"></i>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mobile-booking-bar" *ngIf="isNativeApp && products && products.length > 0 && !isBillDeskPaymentActive && !isBookingConfirmOpen">
    <div class="mobile-cart-empty" *ngIf="mobileCartMessage && selectedSlotsMap.size === 0">
      {{ mobileCartMessage }}
    </div>
    <button
      type="button"
      class="btn mobile-book-now-btn"
      [class.mobile-book-now-btn-disabled]="selectedSlotsMap.size === 0"
      (click)="showModal()">
      Book Now - {{ selectedSlotsMap.size }} {{ selectedSlotsMap.size === 1 ? 'slot' : 'slots' }}
    </button>
  </div>

</div>

<paytm-checkout *ngIf="isCheckoutVisible"></paytm-checkout>

<!-- <script type="application/javascript" src="https://securegw-stage.paytm.in/merchantpgpui/checkoutjs/merchants/NgXarD42151468596686.js" onload="onScriptLoad();" crossorigin="anonymous"></script>
<script>
function onScriptLoad(){
var config = {
"root": "",
"flow": "DEFAULT",
"data": {
"confirmationId": "test1056", /* update order id */
"token": "89c2446b174e4b4096ad10df8d3209dc1676880761206", /* update token value */
"tokenType": "TXN_TOKEN",
"amount": "1.00" /* update amount */
},
"handler": {
"notifyMerchant": function(eventName,data){
console.log("notifyMerchant handler function called");
console.log("eventName => ",eventName);
console.log("data => ",data);
}
}
};
if(window.Paytm && window.Paytm.CheckoutJS){
window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
// initialze configuration using init method
window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
// after successfully updating configuration, invoke JS Checkout
window.Paytm.CheckoutJS.invoke();
}).catch(function onError(error){
console.log("error => ",error);
});
});
}
}
</script> -->
